export enum ColourPickerTab {
    Presets = 0,
    Custom = 1,
}
